import React from 'react';
import PropTypes from 'prop-types';
import { Async } from '@jomaxx/react-async';

export default class AsyncDelay extends React.Component {
  static propTypes = {
    ms: PropTypes.number.isRequired,
  };

  state = {
    value: new Promise(resolve => setTimeout(resolve, this.props.ms)),
  };

  render() {
    return <Async {...this.state} />;
  }
}
